<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Login with your credentials.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign in with credentials</small>
              </div>
              <form
                role="form"
                class="needs-validation"
                @submit.prevent="Login"
              >
                <base-input
                  class="mb-3"
                  append-icon="ni ni-email-83"
                  name="Username"
                  type="text"
                  v-bind:error="nameError"
                  :valid="isValid('Username')"
                  v-validate="'required'"
                  placeholder="Username"
                  v-model="myObj.username"
                >
                </base-input>

                <base-input
                  class="mb-3"
                  append-icon="ni ni-lock-circle-open"
                  :type="showPw ? 'text' : 'password'"
                  placeholder="Password"
                  name="Password"
                  v-bind:error="pwError"
                  :valid="isValid('Password')"
                  v-validate="'required'"
                  v-model="myObj.password"
                >
                </base-input>

                <base-checkbox v-model="user.rememberMe"
                  >Remember me</base-checkbox
                >
                <div class="text-center">
                  <base-button
                    type="primary"
                    :disabled="saving"
                    class="my-4 col"
                    @click="Login"
                    ><i v-bind:class="sign"></i>Sign in</base-button
                  >
                </div>
              </form>
            </div>
          </div>
          <div hidden class="row mt-3">
            <div class="col-6">
              <router-link hidden to="/dashboard" class="text-light"
                ><small>Forgot password?</small></router-link
              >
            </div>
            <div class="col-6 text-right">
              <router-link to="/register" class="text-light"
                ><small>Create new account</small></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import router from "vue";
import swal from "sweetalert2";

export default {
  created() {
    this.$store.commit("domain", "https://mancave.appick.io");
    this.$store.commit("local", "http://localhost:3012");
  },
  data() {
    return {
      showPw: false,
      validated: false,
      myObj: {
        username: "",
        password: "",
      },
      model: {
        userID: "",
        password: "",
        rememberMe: false,
      },
      nameError: false,
      pwError: false,
      saving: false,
      menu: [],
      db: "",
      sign: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.userData;
    },
  },
  methods: {
    async Login() {
      //this.sign = "fas fa-circle-notch fa-spin";
      //this.saving = true;

      if (this.myObj.username === null || this.myObj.username === "") {
        this.nameError = "Please enter username";
      } else {
        this.nameError = false;
        if (this.myObj.password === null || this.myObj.password === "") {
          this.pwError = "Please enter password";
        } else {
          this.pwError = false;

          var url = "https://mancave.appick.io/users/login";
          axios
            .post(url, this.myObj)
            .then((res) => {
              if (res.data.data !== undefined) {
                if (res.data.data.role === "admin") {
                  let resolved = this.$router.resolve("/fusion/dashboard");
                  console.log("Router: ", resolved.route.name);
                  if (resolved.route.name != "404")
                    this.$router.push({
                      name: resolved.route.name,
                      params: {},
                    });
                } else {
                  swal({
                    title: `Unauthorized`,
                    text: "You are not authorized to use this app.",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-error",
                    type: "error",
                  });
                }
              } else {
                swal({
                  title: `Oops`,
                  text: "Invalid username password combination",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-error",
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.error("Login error", error);
            });
        }
      }
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
